module.exports = __webpack_public_path__ + "img/labelPDF.9e4588dc.svg";